import { consumptions } from '../consumption'
import { describeTable } from './describeTable'

describeTable(consumptions, {
  description: `Utility meter readings a homeowner enters in the resident app for their property (electricity, water, heating). Self-reported, sparse and only for the few residents who use the feature — not a company data set. meter_reading is the cumulative meter value on that date; consumption for a period is the difference between two readings. No relation to Markku revenue.`,
  columns: {
    type: 'electricity (kWh), water (m³) or heating (kWh / MWh).',
    date: 'Calendar date of the reading.',
    meterReading:
      'Cumulative meter value; subtract consecutive readings for usage.',
    unit: "Unit the reading is in, as typed ('kWh', 'm³', 'MWh').",
    cost: 'Optional cost in euros the resident entered for the period; gross.',
  },
})
